import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSquareX: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"square-x, close, x, checkbox, remove"} maskId="square-filled-radius-0-stroke-1-IconSquareX"><path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V21H3V3ZM9 8.29289L8.29289 9L11.2929 12L8.29289 15L9 15.7071L12 12.7071L15 15.7071L15.7071 15L12.7071 12L15.7071 9L15 8.29289L12 11.2929L9 8.29289Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSquareX;
